module.exports = __webpack_public_path__ + "img/homepage_1.fe6b0b7a.svg";